import { useCallback, useMemo, useState } from 'react'

type UseTableFiltersReturn<UiRow> = {
  searchQuery: string
  filteredRows: UiRow[]
  handleSearch: (query: string) => void
  handleClearFilters: () => void
}

const matchesSearch = <UiRow>(row: UiRow, query: string): boolean => {
  const lower = query.toLowerCase()
  return Object.values(row as Record<string, unknown>).some((value) => {
    if (value === null || value === undefined) return false
    return String(value).toLowerCase().includes(lower)
  })
}

const useTableFilters = <UiRow>(rows: UiRow[]): UseTableFiltersReturn<UiRow> => {
  const [searchQuery, setSearchQuery] = useState<string>('')

  const filteredRows = useMemo<UiRow[]>(() => {
    if (!searchQuery.trim()) return rows
    return rows.filter((row) => matchesSearch(row, searchQuery))
  }, [rows, searchQuery])

  const handleSearch = useCallback((query: string): void => {
    setSearchQuery(query)
  }, [])

  const handleClearFilters = useCallback((): void => {
    setSearchQuery('')
  }, [])

  return { searchQuery, filteredRows, handleSearch, handleClearFilters }
}

export default useTableFilters
